// !Empty file to avoid Sentry initialization on the client side

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// import * as Sentry from "@sentry/nextjs";
// import LogRocket from "logrocket";

// let userInfo = localStorage.getItem("userInfo") || undefined;
// try {
//   if (userInfo) userInfo = JSON.parse(userInfo);
// } catch (e) {
//   userInfo = undefined;
// }

// LogRocket.init("cnbk3r/test-first-app");
// LogRocket.identify("43");

// Sentry.init({
//   dsn: "https://cd6e39962c235561f98ef58cfe8fa8c7@o4508142720778240.ingest.us.sentry.io/4508142723072000",

//   // Add optional integrations for additional features
//   integrations: [
//     Sentry.replayIntegration({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],

//   beforeSend(event) {
//     console.log("🚀 ~ beforeSend ~ event:", event);
//     const logRocketSession = LogRocket.sessionURL;
//     if (event.extra && logRocketSession !== null) {
//       event.extra["LogRocket"] = logRocketSession;
//       return event;
//     } else {
//       return event;
//     }
//   },

//   // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
//   tracesSampleRate: 1,

//   // Define how likely Replay events are sampled.
//   // This sets the sample rate to be 10%. You may want this to be 100% while
//   // in development and sample at a lower rate in production
//   replaysSessionSampleRate: 0.1,

//   // Define how likely Replay events are sampled when an error occurs.
//   replaysOnErrorSampleRate: 1.0,

//   // Setting this option to true will print useful information to the console while you're setting up Sentry.
//   debug: true,
//   initialScope: {
//     tags: { "my-tag": "my value" },
//     user: { id: 43, email: "1212121.doe@example.com" },
//   },
// });

// LogRocket.getSessionURL((sessionURL) => {
//   Sentry.configureScope((scope: any) => {
//     scope.setExtra("sessionURL", sessionURL);
//   });
// });
;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8fdfd64ed50fd44ae410c789494a54b9b6ca6fdf"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";